module.exports = function (html) {
    var content = html.replace('<body', '<div id="xhrBody"').replace('</body>', '</div>')
    let fakeDom = document.createElement('div')
    fakeDom.innerHTML = content

    var json = {
        content:  fakeDom.innerHTML,
        title: fakeDom.querySelector('title').innerText,
        pageClass:  fakeDom.querySelector('#xhrBody').className,
        originalContent: html
    }
    return json;
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/getDataFromHtml.js